import React, { useState } from 'react';
import '../CSS/Retail.css';

const Retail: React.FC = () => {
  const [activeCollapsible, setActiveCollapsible] = useState(0);

  const handleCollapsibleClick = (index: number) => {
    setActiveCollapsible(index);
  };

  return (
    <div className="retail-page">
      <div className="retail_banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Retail</h1>
        </div>
      </div>

      {/* Retail Collapsible Section - Desktop */}
      <div className="retail_collapsible desktop-retail-collapsible">
        <div className="retail-collapsible-content">
          <div className="retail-collapsible-intro">
            <p>Artificial Intelligence is going hand in hand with Data Engineering that reshapes retail from the inside out, affecting almost every part of customer experiences both in brick and mortar and online stores.</p>
          </div>
          <div className="retail-collapsible-cards">
            <div 
              className={`retail-collapsible-card ${activeCollapsible === 0 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(0)}
            >
              <div className="retail-card-header">
                <div className="retail-card-icon">
                  <img src="/Assets/Icons/demand-management-icon.svg" alt="Demand Management" />
                </div>
                <div className="retail-card-title">
                  <h3>Demand Management</h3>
                  <div className="retail-card-arrow">
                    <img 
                      src={activeCollapsible === 0 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                      alt="Toggle" 
                    />
                  </div>
                </div>
              </div>
              {activeCollapsible === 0 && (
                <div className="retail-card-content">
                  <p>Demand management in retail includes analyzing numerous internal and external variables that impact demand -from seasonality to promotions and inventory levels to market trends. With it, retailers can more effectively improve stock management, reduce storage costs, and prevent stock-outs.</p>
                </div>
              )}
            </div>

            <div 
              className={`retail-collapsible-card ${activeCollapsible === 1 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(1)}
            >
              <div className="retail-card-header">
                <div className="retail-card-icon">
                  <img src="/Assets/Icons/inventory-pricing-optimization-icon.svg" alt="Inventory & Pricing Optimization" />
                </div>
                <div className="retail-card-title">
                  <h3>Inventory & Pricing Optimization</h3>
                  <div className="retail-card-arrow">
                    <img 
                      src={activeCollapsible === 1 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                      alt="Toggle" 
                    />
                  </div>
                </div>
              </div>
              {activeCollapsible === 1 && (
                <div className="retail-card-content">
                  <p>By analyzing vast amounts of data, behavioral customer data, and seasonal trends included, AI models can consider multiple different scenarios, suggest the most relevant price, and evaluate the impact of sales promotions on given product categories.</p>
                </div>
              )}
            </div>

            <div 
              className={`retail-collapsible-card ${activeCollapsible === 2 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(2)}
            >
              <div className="retail-card-header">
                <div className="retail-card-icon">
                  <img src="/Assets/Icons/shelf-signing-analysis-icon.svg" alt="Shelf and Signing Analysis with Computer Vision" />
                </div>
                <div className="retail-card-title">
                  <h3>Shelf and Signing Analysis with Computer Vision</h3>
                  <div className="retail-card-arrow">
                    <img 
                      src={activeCollapsible === 2 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                      alt="Toggle" 
                    />
                  </div>
                </div>
              </div>
              {activeCollapsible === 2 && (
                <div className="retail-card-content">
                  <p>Computer vision solutions are to detect natural objects placed on store shelves and classify them based on category, brand, and item, streamlining manual, time-consuming, and error-prone store audits.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Retail Collapsible Section - Mobile (480px) */}
      <div className="retail_collapsible mobile-retail-collapsible">
        <div className="mobile-retail-collapsible-content">
          <div className="mobile-retail-collapsible-intro">
            <p>Artificial Intelligence is going hand in hand with Data Engineering that reshapes retail from the inside out, affecting almost every part of customer experiences both in brick and mortar and online stores.</p>
          </div>
          <div className="mobile-retail-collapsible-cards">
            <div 
              className={`mobile-retail-collapsible-card ${activeCollapsible === 0 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(0)}
            >
              <div className="mobile-retail-card-header">
                <div className="mobile-retail-card-icon">
                  <img src="/Assets/Icons/demand-management-icon.svg" alt="Demand Management" />
                </div>
                <div className="mobile-retail-card-title">
                  <h3>Demand Management</h3>
                  <div className="mobile-retail-card-arrow">
                    <img 
                      src={activeCollapsible === 0 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                      alt="Toggle" 
                    />
                  </div>
                </div>
              </div>
              {activeCollapsible === 0 && (
                <div className="mobile-retail-card-content">
                  <p>Demand management in retail includes analyzing numerous internal and external variables that impact demand -from seasonality to promotions and inventory levels to market trends. With it, retailers can more effectively improve stock management, reduce storage costs, and prevent stock-outs.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-retail-collapsible-card ${activeCollapsible === 1 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(1)}
            >
              <div className="mobile-retail-card-header">
                <div className="mobile-retail-card-icon">
                  <img src="/Assets/Icons/inventory-pricing-optimization-icon.svg" alt="Inventory & Pricing Optimization" />
                </div>
                <div className="mobile-retail-card-title">
                  <h3>Inventory & Pricing Optimization</h3>
                  <div className="mobile-retail-card-arrow">
                    <img 
                      src={activeCollapsible === 1 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                      alt="Toggle" 
                    />
                  </div>
                </div>
              </div>
              {activeCollapsible === 1 && (
                <div className="mobile-retail-card-content">
                  <p>By analyzing vast amounts of data, behavioral customer data, and seasonal trends included, AI models can consider multiple different scenarios, suggest the most relevant price, and evaluate the impact of sales promotions on given product categories.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-retail-collapsible-card ${activeCollapsible === 2 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(2)}
            >
              <div className="mobile-retail-card-header">
                <div className="mobile-retail-card-icon">
                  <img src="/Assets/Icons/shelf-signing-analysis-icon.svg" alt="Shelf and Signing Analysis with Computer Vision" />
                </div>
                <div className="mobile-retail-card-title">
                  <h3>Shelf and Signing Analysis with Computer Vision</h3>
                  <div className="mobile-retail-card-arrow">
                    <img 
                      src={activeCollapsible === 2 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                      alt="Toggle" 
                    />
                  </div>
                </div>
              </div>
              {activeCollapsible === 2 && (
                <div className="mobile-retail-card-content">
                  <p>Computer vision solutions are to detect natural objects placed on store shelves and classify them based on category, brand, and item, streamlining manual, time-consuming, and error-prone store audits.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Retail Pairing Section - Desktop */}
      <div className="retail_pairing desktop-retail-pairing">
        <div className="retail_pairing-content">
          {/* Main Title */}
          <h2 className="retail_pairing-title">Our solutions</h2>
          
          {/* First Pairing - Demand Review & Management */}
          <div className="retail_image_right">
            <div className="section-image">
              <img src="/Assets/Retail/demand-review-section-image.png" alt="Demand Review & Management" />
            </div>
            <div className="retail_section_text">
              <h3 className="retail_section_title">Demand Review & Management</h3>
              <p className="retail_section_description">AI solutions for retail and ML methods help to perform accurate demand trend analysis based on unique target groups' shopping behaviors while understanding the seasonal trends. </p>
              <p className="retail_section_description">By connecting and analyzing data from separated silos, AI applications provide retailers with a comprehensive view of store inventory to prevent stock-out occurrences on the one hand and – on the other – to optimize product placement to increase sales.</p>
            </div>
            
          </div>

          {/* Second Pairing - Pricing Adjustment */}
          <div className="retail_image_left">
            <div className="section-image">
              <img src="/Assets/Retail/pricing-adjustment-section-image.png" alt="Pricing Adjustment" />
            </div>
            <div className="retail_section_text">
              <h3 className="retail_section_title">Pricing Adjustment</h3>
              <p className="retail_section_description">With AI agents that analyze competitor pricing strategies, commerce businesses can fix the best product price that attracts customers at the moment. They deliver real-time price optimization based on market conditions.</p>
            </div>
          </div>

          {/* Third Pairing - Personalization in Search & Recommendation */}
          <div className="retail_image_right">
            <div className="section-image">
              <img src="/Assets/Retail/personalization-in-search-section-image.png" alt="Personalization in Search & Recommendation" />
            </div>
            <div className="retail_section_text">
              <h3 className="retail_section_title">Personalization in Search & Recommendation</h3>
              <p className="retail_section_description">Our Personalize AI Agent enable brands to implement personalization in search engines or loyalty programs to provide customers with tailored offerings and increase the average value order, increase customer engagement, improve loyalty and - last but not least - boost conversion rate.</p>
            </div>

          </div>

          {/* Fourth Pairing - Unified Data Environments */}
          <div className="retail_image_left">
            <div className="section-image">
              <img src="/Assets/Retail/unified-data-environments-section-image.png" alt="Unified Data Environments" />
            </div>
            <div className="retail_section_text">
              <h3 className="retail_section_title">Unified Data Environments</h3>
              <p className="retail_section_description">We design and develop sophisticated and aligned with the unique business needs, data pipelines, that transform data to one format and transport them to a unified data environment.</p>
              <p className="retail_section_description">The pipelines collect data from many disparate silos and collect them into a single warehouse, providing organizations with one single "source of truth" which enables multi departments to make smart business decisions.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Retail Pairing Section - Mobile (480px) */}
      <div className="retail_pairing mobile-retail-pairing">
        <div className="retail_pairing-content">
          {/* Main Title */}
          <h2 className="retail_pairing-title">Our solutions</h2>
          
          {/* First Pairing - Demand Review & Management - Text Above Image */}
          <div className="mobile-retail-section">
            <div className="mobile-retail-text">
              <h3 className="mobile-retail-title">Demand Review & Management</h3>
              <p className="mobile-retail-description">AI solutions for retail and ML methods help to perform accurate demand trend analysis based on unique target groups' shopping behaviors while understanding the seasonal trends. </p>
              <p className="mobile-retail-description">By connecting and analyzing data from separated silos, AI applications provide retailers with a comprehensive view of store inventory to prevent stock-out occurrences on the one hand and – on the other – to optimize product placement to increase sales.</p>
            </div>
            <div className="mobile-retail-image">
              <img src="/Assets/Retail/demand-review-section-image.png" alt="Demand Review & Management" />
            </div>
          </div>

          {/* Second Pairing - Pricing Adjustment - Text Above Image */}
          <div className="mobile-retail-section">
            <div className="mobile-retail-text">
              <h3 className="mobile-retail-title">Pricing Adjustment</h3>
              <p className="mobile-retail-description">With AI agents that analyze competitor pricing strategies, commerce businesses can fix the best product price that attracts customers at the moment. They deliver real-time price optimization based on market conditions.</p>
            </div>
            <div className="mobile-retail-image">
              <img src="/Assets/Retail/pricing-adjustment-section-image.png" alt="Pricing Adjustment" />
            </div>
          </div>

          {/* Third Pairing - Personalization in Search & Recommendation - Text Above Image */}
          <div className="mobile-retail-section">
            <div className="mobile-retail-text">
              <h3 className="mobile-retail-title">Personalization in Search & Recommendation</h3>
              <p className="mobile-retail-description">Our Personalize AI Agent enable brands to implement personalization in search engines or loyalty programs to provide customers with tailored offerings and increase the average value order, increase customer engagement, improve loyalty and - last but not least - boost conversion rate.</p>
            </div>
            <div className="mobile-retail-image">
              <img src="/Assets/Retail/personalization-in-search-section-image.png" alt="Personalization in Search & Recommendation" />
            </div>
          </div>

          {/* Fourth Pairing - Unified Data Environments - Text Above Image */}
          <div className="mobile-retail-section">
            <div className="mobile-retail-text">
              <h3 className="mobile-retail-title">Unified Data Environments</h3>
              <p className="mobile-retail-description">We design and develop sophisticated and aligned with the unique business needs, data pipelines, that transform data to one format and transport them to a unified data environment.</p>
              <p className="mobile-retail-description">The pipelines collect data from many disparate silos and collect them into a single warehouse, providing organizations with one single "source of truth" which enables multi departments to make smart business decisions.</p>
            </div>
            <div className="mobile-retail-image">
              <img src="/Assets/Retail/unified-data-environments-section-image.png" alt="Unified Data Environments" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Retail; 